export enum Currency {
    USD = 'USD',
    VND = 'VND',
}

export enum LocaleCurrency {
    USD = 'en-US',
    VND = 'vi-VN',
}
